"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelListItem = exports.PanelListAnchor = exports.PanelList = void 0;
exports.PrimaryNavTrayPanelList = PrimaryNavTrayPanelList;
exports.PrimaryNavTrayPanelListItem = PrimaryNavTrayPanelListItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const PanelList = exports.PanelList = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "PanelList",
  class: "pl-pi8oij0",
  vars: {
    "pi8oij0-0": [({
      isOpen
    }) => isOpen ? '1' : '0']
  }
});
const PanelListItem = exports.PanelListItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "PanelListItem",
  class: "pl-puf8dkv"
});
const PanelListAnchor = exports.PanelListAnchor = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "PanelListAnchor",
  class: "pl-p1csasmx"
});

/**
 * Primary Nav Tray Panel List Item component.
 *
 * @param {Object} props React props
 * @param {string} props._name name for tracking
 * @param {string} props.text text string
 * @param {string} props.href Href string
 * @returns {React.ReactElement} Primary Nav Tray Panel List Item
 * @public
 */
function PrimaryNavTrayPanelListItem({
  text,
  href,
  _name
}) {
  return /*#__PURE__*/_react.default.createElement(PanelListItem, {
    "data-cy": "primary-nav-tray-panel-list-item"
  }, href ? /*#__PURE__*/_react.default.createElement(PanelListAnchor, (0, _extends2.default)({
    "data-cy": "optional-panel-list-anchor",
    href: href
  }, _patternLibraryUtils.tracking.create(_name, true, false)), text) : {
    text
  });
}
PrimaryNavTrayPanelListItem.propTypes = {
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  href: _propTypes.default.string,
  _name: _propTypes.default.string
};

/**
 * Primary Nav Tray Panel List component.
 *
 * @param {Object} props React props
 * @param {string} props.title Title
 * @param {string} props.titleHref Href for title
 * @param {array} props.menuItems menu items
 * @param {boolean} props.isOpen Open flag
 * @returns {React.ReactElement} Primary Nav Tray Panel List
 * @public
 */
function PrimaryNavTrayPanelList({
  title,
  titleHref,
  menuItems,
  isOpen
}) {
  return /*#__PURE__*/_react.default.createElement(PanelList, {
    "data-cy": "primary-nav-tray-panel-list",
    isOpen: isOpen
  }, title && /*#__PURE__*/_react.default.createElement(PanelListItem, null, titleHref ? /*#__PURE__*/_react.default.createElement(PanelListAnchor, {
    "data-cy": "optional-panel-list-anchor",
    href: titleHref
  }, title) : title), menuItems?.map(({
    _name,
    title: text,
    href
  }, i) => /*#__PURE__*/_react.default.createElement(PrimaryNavTrayPanelListItem, {
    key: i,
    _name: _name,
    text: text,
    href: href
  })));
}
PrimaryNavTrayPanelList.propTypes = {
  title: _propTypes.default.string,
  titleHref: _propTypes.default.string,
  menuItems: _propTypes.default.array,
  isOpen: _propTypes.default.bool
};